/**
 * Pure utility functions for streak calculation.
 * Extracted from useStreak hook for testability.
 */

export function getISOWeekKey(date: Date): string {
  const d = new Date(date);
  const day = d.getUTCDay(); // 0=Sun
  const diff = d.getUTCDate() - day + (day === 0 ? -6 : 1);
  d.setUTCDate(diff);
  d.setUTCHours(0, 0, 0, 0);
  return d.toISOString().slice(0, 10);
}

export function getWeekOffset(weekKey: string, offset: number): string {
  const d = new Date(weekKey);
  d.setDate(d.getDate() + offset * 7);
  return d.toISOString().slice(0, 10);
}
